import React, { Component } from 'react';

class DieCounter extends Component {
  constructor(props) {
    super();
    this.state = {
      count: 0
    }
    // What dice to use inside this counter?
    this.dieClass = props.dieClass;
  }

  add() {
    this.setState({count:this.state.count+1})
  }

  remove() {
    if (this.state.count > 0) {
      this.setState({count:this.state.count-1})
    }
  }

  reset() {
    this.setState({count: 0});
  }

  roll() {
    var i, result = [];

    for(i=0; i<this.state.count; i++) {
      result.push(this.refs.die.roll());
    }

    return {
      type: this.dieClass.type,
      result: result
    }
  }

  render() {
    const cls = c => `roller_die_counter_${c}`;

    return (
      <div className={cls('container')}>
        <div className={cls('btn_container')}>
          <button style={{ marginBottom: 3 }} className={cls('btnStyle')} onClick={this.add.bind(this)}>⬆</button>
          <button className={cls('btnStyle btnXSmall')} onClick={this.remove.bind(this)}>⬇</button>
        </div>
        <this.dieClass ref="die" />
        <div className={cls('counterStyle')}>
          {this.state.count}
        </div>
      </div>
    );
  }
}

export default DieCounter;



// WEBPACK FOOTER //
// ./src/Roller/DieCounter.js